export const typeToApiFields = {
  animals: "animalIds",
  devices: "deviceIds",
  deployments: "deploymentIds",
  files: "filePaths",
};
